import {ButtonBase, styled} from '@mui/material';

const InstructionsSummary = styled(ButtonBase)`
	display: flex;
	justify-content: space-between;
	width: 100%;
	padding: 16px;
	border-radius: 8px;
	background-color: ${({theme}) => theme.palette.background.paper};
	text-align: left;
`;

export {InstructionsSummary};
